/**
 * 动态
 */
import React, {Component} from 'react';
import ReactDOM, {render} from 'react-dom';

import url from 'c-url';
import notification from 'c-notification';

// import shareClick from '../component/shareclick/index';
import dl from '../component/download/dl';
import Feed from '../component/feed/index';
import UserInfo from '../feedshare/userinfo';
import ImageTypeView from '../feedshare/image';
import VideoTypeView from '../feedshare/video'
import CommentView from '../feedshare/comment';;
import HotVideoList from '../videolist/index';
import PersonVideoList from '../videolist/person';

import lang from '../lang/index';

const AppWrapper = (ComposedComponent) => {
    return class FeedInfo extends Component {
        
        static defaultProps = {
            rid: '',
            dynamicId: ''
        }

        constructor(props) {
            super(props);

            this.state = {
                data: null,
                fetching: true,
                listType: 'hot'
            };

            this.rid = url.query('rid');
            this.dynamicId = url.query('dynamicId');
        }

        componentDidMount() {
            $.channel.on('download', ()=>{
                dl();
            })
            
            // shareClick.send({
            //     targetId: url.query('dynamicId'),
            //     type: 'dynamic'
            // });

            $(window).on('scroll', ()=>{
                this.refs.list && this.refs.list.scroll();
            })
        }

        componentWillUnmount(){
            $(window).off('scroll');
        }

        componentWillMount() {
            if (!this.rid || !this.dynamicId) {
                notification.simple('parameter error');
                return;
            }
            this.getFeedInfo();
        }   

        getFeedInfo() {
            let self = this;
            let promise = new Feed({
                rid: parseInt(this.rid, 10),
                dynamicId: parseInt(this.dynamicId, 10)
            }).promise;

            promise.done((data)=>{
                if (data.errmsg) {
                    this.setState({
                        fetching: false,
                        errmsg: data.errmsg == 'noexist' ? lang.template('哎哟，页面不见了') : lang.template('哎哟，页面无法查看，请稍候再试')
                    });
                } else {
                    self.uid = window.longToString(data.dynamicInfo.userInfo.uid);
                    this.setState({
                        data: data,
                        fetching: false
                    });
                }
            });

            promise.fail(()=>{
                this.setState({
                    fetching: false,
                    errmsg: lang.template('哎哟，页面无法查看，请稍候再试')
                });
            })
        }

        selectList(type){
            if (this.state.listType == type){
                return;
            }

            this.setState({
                listType: type
            });
        }  

        render() {
            let $content;

            if (this.state.fetching) {
                return (
                    <div className="mini-loading">
                        <div className="loading-tip">{lang.template('正在加载')}<em>.</em><em>.</em><em>.</em></div>
                    </div>
                );
            } else {

                if (this.state.errmsg) {
                    $content = (
                        <div className="content-wrapper">
                            <div className="mini-notice">
                                <i></i>
                                <span className="tip">{ this.state.errmsg }</span>
                            </div>
                            <div className="btns">
                                <div className="btn" onClick={()=> $.channel.emit('download')}>{ lang.template('打开Up直播，直播全世界') }</div>
                            </div>
                        </div>
                    )
                } else {
                    let { dynamicInfo, comments } = this.state.data;

                    $content = (
                        <div>
                            <ComposedComponent dynamicInfo={dynamicInfo} />    
                            <UserInfo dynamicInfo={dynamicInfo} />
                            { 
                                // comments.length >= 3 ? <CommentView comments={comments}/>:  null 
                            }
                        </div>
                    )
                    
                }

                let listType = this.state.listType;
                let $list;
                
                if (listType == 'host' && this.uid){
                    $list = <PersonVideoList uid={this.uid} ref="list"/>
                } else {
                    $list = <HotVideoList/>
                }
                return (
                    <div className="app-home">
                        { $content }

                        <div className="hotlist-wrapper">
                            <div className="hotlist-header">
                                <h2 onClick={()=>this.selectList('hot')}>
                                    <span className={this.state.listType == 'hot' ? "selected":""}>{ lang.template('热门视频') }</span>
                                </h2>  
                                <h2 onClick={()=>this.selectList('host')}>
                                    <span className={this.state.listType == 'host' ? "selected":""}>{ lang.template('TA的视频') }</span>
                                </h2>                   
                            </div>
                            
                            { $list }
                            
                        </div>
                    </div>
                );
            }
        }
    }
}

class App extends Component {
    static defaultProps = {
        dynamicInfo: {}
    }

    constructor(props){
        super(props);

        this.state = {
            type: props.dynamicInfo.dynamicType // 1: 图文，2：视频，文;5:录屏,文
        }
    }   

    render() {
        let $content = null;
        
        switch(this.state.type) {
            case 1: 
                $content = <ImageTypeView data={this.props.dynamicInfo}/>;
                break;
            case 2:
            case 5: 
            case 7:
                $content = <VideoTypeView data={this.props.dynamicInfo}/>;
                break;
        }

        return $content;
    }

}

export default AppWrapper(App);


// WEBPACK FOOTER //
// ./js/dynamic/index.js